import { useEffect } from "react"
import Navbar from "../../components/admin/Navbar.tsx";
import { Outlet } from "react-router-dom";

/**
 * Represents the home page of the application.
 * It includes a navigation bar, a navigation section, sports schedule, and a schedule table.
 * @returns JSX elements representing the home page layout.
 */
const LayoutComponent = () => {
    useEffect(() => {
        document.body.classList.add("admin-body");
        return () => {
            document.body.classList.remove("admin-body");
        };
    }, []);
    return (

        <>
            <Navbar />
            <div className='container-fluid admin-shell px-0'>
                <div className='row g-0'>
                    <div className='col-12'>
                        <Outlet />
                    </div>
                </div>
            </div>
        </>
    );
}
export default LayoutComponent;
